import { useEffect } from 'react'
import { useAtom, useSetAtom } from 'jotai'
import { omanRegionsAtom, omanCountryListAtom, isLoadingOmanGeoAtom } from '../stores/oman.store'
import { fetchOmanRegions, fetchOmanCountryList } from '../services/oman.api'

/** Fetches country list + regions in parallel on mount. Safe to call multiple times — skips if already loaded. */
export const useOmanGeo = (countryCode = 'OM') => {
    const [regions, setRegions] = useAtom(omanRegionsAtom)
    const [countryList, setCountryList] = useAtom(omanCountryListAtom)
    const setLoading = useSetAtom(isLoadingOmanGeoAtom)

    useEffect(() => {
        if (regions.length > 0 && countryList.length > 0) return

        setLoading(true)
        Promise.all([fetchOmanRegions(countryCode), fetchOmanCountryList()])
            .then(([fetchedRegions, fetchedCountries]) => {
                setRegions(fetchedRegions)
                setCountryList(fetchedCountries)
            })
            .catch(() => {
                // geo data not critical — leave arrays empty, UI will handle gracefully
            })
            .finally(() => setLoading(false))
    }, [countryCode, regions.length, countryList.length, setRegions, setCountryList, setLoading])

    return { regions, countryList }
}
